export enum EFlowActionPanelEvent {
  ZOOM_IN = 'ZOOM_IN',
  ZOOM_OUT = 'ZOOM_OUT',
  ONE_TO_ONE = 'ONE_TO_ONE',
  FIT_TO_SCREEN = 'FIT_TO_SCREEN',
  TEST_CALL = 'TEST_CALL',
  SELECT_ALL = 'SELECT_ALL',
  DELETE_SELECTED = 'DELETE_SELECTED',
  TOGGLE_CONTENT_VIEW = 'TOGGLE_CONTENT_VIEW',
  ALIGN_CONTENT_VERTICALLY = 'ALIGN_CONTENT_VERTICALLY',
}
